// src/utils/supportAxios.js
import axios from 'axios';

const supportAxios = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:31000',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

supportAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('supportToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

supportAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Support API error:', error.response?.status, error.response?.data || error.message);
    if (error.response?.status === 401) {
      localStorage.removeItem('supportToken');
      localStorage.removeItem('supportUser');
      if (!window.location.pathname.includes('/support/login')) {
        window.location.href = '/support/login';
      }
    }
    return Promise.reject(error);
  }
);

export default supportAxios;